import styled from 'styled-components';
import { media } from '@prisjakt/ui-base';

export const ForumTopic = styled.div`
  display: flex;
  flex-direction: column;
  ${media.mediumUp`
      flex-direction: row;
   `}
`;

export const Topics = styled.div`
  display: grid;
  grid-gap: 10px;
  flex: 1;
  ${media.mediumUp`
  grid-template-columns: repeat(3, 30%);
   `}
`;

export const Forum = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  svg {
    fill: ${p => p.theme.colors.base300};
    margin-bottom: 1em;
  }
`;
